var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconEmployee = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-35,20h-9.918c.556-3.388,3.9-6,7.918-6a8.759,8.759,0,0,1,4.488,1.207,1,1,0,0,0,1.371-.348,1,1,0,0,0-.347-1.371,10.432,10.432,0,0,0-1.76-.81A5.987,5.987,0,0,0-31,8a6,6,0,0,0-6-6,6,6,0,0,0-6,6,5.985,5.985,0,0,0,2.234,4.668A9.068,9.068,0,0,0-47,21a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1A1,1,0,0,0-35,20ZM-41,8a4,4,0,0,1,4-4,4,4,0,0,1,4,4,4,4,0,0,1-4,4A4,4,0,0,1-41,8Zm14,11a1,1,0,0,1-1,1h-1v1a1,1,0,0,1-1,1,1,1,0,0,1-1-1V20h-1a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1V17a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h1A1,1,0,0,1-27,19Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmployee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-employee.c2d81ab3.svg";
export { ForwardRef as ReactComponent };